/*
 * File: ProductFilterOptions.tsx
 * Project: meki
 * File Created: Wednesday, 11th August 2021 6:35:45 pm
 * Author: Luis Aparicio (luis@inventures.cl)
 * -----
 * Last Modified: Monday, 27th November 2023 5:22:10 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */

import React from 'react';
import { Badge, Menu, MenuItem } from '@mui/material';
import Fade from '@mui/material/Fade';
import ImportExportOutlinedIcon from '@mui/icons-material/ImportExportOutlined';
import TuneIcon from '@mui/icons-material/Tune';
import { styled } from '@mui/system';
const ButtonGroup = styled('div')`
  display: flex;
  gap: 11px;
  justify-content: center;
  margin: 0 12px;
  ${(props) => props.theme.breakpoints.up(700)} {
    justify-content: flex-end;
  }
`;
const Button = styled('button')`
  background-color: white;
  color: #0a7abe;
  text-transform: unset;
  padding: 6px 26px;
  border-radius: 100px;
  border: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 150px;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
`;
interface ProductFilterOptionsProps {
  handleToggleDrawer: () => void;
  handleSort?: (type: string) => void;
  totalFiltersCheck?: number;
  sortType?: string;
}
export function ProductFilterOptions(props: ProductFilterOptionsProps) {
  const { handleToggleDrawer, totalFiltersCheck, handleSort, sortType } = props;

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <ButtonGroup>
      <Button onClick={handleToggleDrawer}>
        Filtrar{' '}
        {totalFiltersCheck > 0 ? (
          <Badge badgeContent={totalFiltersCheck} color="primary"></Badge>
        ) : (
          <TuneIcon />
        )}
      </Button>
      <Button onClick={handleClick}>
        Ordenar
        <ImportExportOutlinedIcon />
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        TransitionComponent={Fade}
        variant={'selectedMenu'}
      >
        <MenuItem
          onClick={() => {
            handleClose();
            handleSort('mostSelling');
          }}
          // component={'button'}
          selected={sortType === 'mostSelling'}
        >
          Más vendidos
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            handleSort('price');
          }}
          selected={sortType === 'price'}
        >
          Precio
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            handleSort('alphabetically');
          }}
          selected={sortType === 'alphabetically'}
        >
          A - Z
        </MenuItem>
      </Menu>
    </ButtonGroup>
  );
}
